import api from "services/api";

const URL = "/enterprise";

class EnterpriseService {
  getAll() {
    return api.get(URL);
  }

  getById(id) {
    return api.get(`${URL}/${id}`);
  }

  search(params) {
    return api.get(`${URL}/search`, { params });
  }

  create(data) {
    return api.post(URL, data);
  }

  update(id, data) {
    return api.put(`${URL}/${id}`, data);
  }

  delete(id) {
    return api.delete(`${URL}/${id}`);
  }
}

const enterpriseService = new EnterpriseService();
export default enterpriseService;
